/**
 * The numbers this account can call out on, and which one it uses by default.
 *
 * Read by the rail, which draws the list and - while that section is shut - the
 * one line that matters, so the fetch belongs beside neither of them.
 */
import { useEffect, useState } from "react";
import { listCallerIds, type CallerIdRow } from "../../../../lib/calls";

export interface CallerLines {
  rows: CallerIdRow[];
  /** The account's own caller id, as the server reports it. "" until it lands. */
  selected: string;
}

export function useCallerLines(): CallerLines {
  const [lines, setLines] = useState<CallerLines>({ rows: [], selected: "" });

  useEffect(() => {
    listCallerIds()
      // Guarded past the first level. A 200 whose body is one key thinner than
      // expected used to reach `lines.rows.length` as undefined and throw, which
      // took the whole desk down - the exact failure the error boundary was
      // added for, and one worth not needing the boundary for.
      .then((r) => setLines({ rows: Array.isArray(r?.callerIds) ? r.callerIds : [], selected: r?.selected ?? "" }))
      .catch(() => {});
  }, []);

  return lines;
}
